export class TransferStatus {
  static WithdrawTransferStatus = {
    Untransferred: 'Untransferred',
    Draft: 'Draft',
    Pending: 'Pending',
    Success: 'Success',
    Fail: 'Fail',
  };
}
